export const isNoItemsAvailable = (searchable, searchQuery, items) =>
  (searchable && !searchQuery && items.length === 0) ||
  (!searchable && items.length === 0)
